
import { Component } from '@theme/component';
import { CartAddEvent } from '@theme/events';
import { isMobileBreakpoint, isTouchDevice } from '@theme/utilities';

export class BestSellersMybike extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    /** @type {NodeListOf<HTMLButtonElement>} */
    this.addButtons = this.querySelectorAll('.best-sellers__add');
    this.#setupAddButtons();
  }

  #setupAddButtons() {
    if (!this.addButtons) return;
    this.addButtons.forEach(btn => {
      btn.addEventListener('click', (e) => this.#handleAddSingle(e));
    });
  }

  get cartAddUrl() {
    // @ts-ignore
    return (typeof Theme !== 'undefined' && Theme.routes?.cart_add_url) || '/cart/add.js';
  }

  /**
   * @param {HTMLElement} button 
   * @param {string} imageUrl 
   */
  #flyToCart(button, imageUrl) {
    if (!imageUrl) return;

    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (!cartIcon) return;

    // @ts-ignore
    const flyToCartElement = document.createElement('fly-to-cart');

    flyToCartElement.classList.add('fly-to-cart--main');
    flyToCartElement.style.setProperty('background-image', `url(${imageUrl})`);
    flyToCartElement.style.setProperty('--start-opacity', '0');

    // @ts-ignore
    flyToCartElement.source = button;
    // @ts-ignore
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  }

  /** @param {Event} event */
  async #handleAddSingle(event) {
    const btn = event.currentTarget;
    if (!(btn instanceof HTMLButtonElement) || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    const productMedia = btn.dataset.productMedia;
    if (!variantId || !productMedia) return;

    event.preventDefault(); // Prevent navigating if wrapped in a link
    
    btn.disabled = true;
    const originalText = btn.innerHTML;
    btn.innerHTML = '...';

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    
    /** @type {string[]} */
    const sectionsToUpdate = [];
    cartItemsComponents.forEach((com) => {
      if (com instanceof HTMLElement && com.dataset.sectionId) {
        sectionsToUpdate.push(com.dataset.sectionId);
      }
    });

    try {
      const payload = {
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionsToUpdate.join(','),
      };

      this.#flyToCart(btn, productMedia);

      const response = await fetch(this.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const responseData = await response.json();

      if (response.ok && !responseData.status) {
        this.dispatchEvent(
          new CartAddEvent(responseData, variantId.toString(), {
            source: 'best-sellers-add-one',
            itemCount: 1,
            sections: responseData.sections,
          })
        );
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        btn.innerHTML = 'Añadido';
      } else {
        btn.innerHTML = 'Error';
      }
    } catch (err) {
      console.error(err);
      btn.innerHTML = 'Error';
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = originalText;
      }, 2000);
    }
  }
}

if (!customElements.get('best-sellers-mybike')) {
  customElements.define('best-sellers-mybike', BestSellersMybike);
}
